import {AxiosError} from "axios";

const AXIOS_CONNECTION_ERR_CODE = "ECONNABORTED";
const AXIOS_NO_NETWORK_ERR_MSG = "Network Error";

const strings = {
    noNetwork: "We were unable to reach the internet. Please verify your connection and try again.",
    serverError: "An unexpected error has occurred. Please wait a minute and try again.",
    genericValidation: "An error has occurred. Please double check the form and try again.",
    dataError: "An unexpected error has occurred. Please refresh the page and try again.",
};

export type Validation = {
    generic?: string[];
    errors?: {[key: string]: string[]};
};

export function isAxiosError(value: unknown): value is AxiosError {
    return (value as AxiosError)?.isAxiosError;
}

export function getValidationObj(err: unknown): Validation {
    if (isAxiosError(err)) {
        const errors = err.response?.data.errors;
        const generic = err.response?.data.generic;
        if (errors || generic) {
            const finalValidation = {
                generic,
                errors,
            };
            if (errors?.generic) {
                finalValidation.generic = finalValidation.generic
                    ? [...finalValidation.generic, ...errors.generic]
                    : errors.generic;
                finalValidation.errors = {
                    ...errors,
                };
                delete finalValidation.errors.generic;
            }
            return finalValidation;
        }

        let errorMessage;
        if (err.response?.status === 400) {
            errorMessage = strings.genericValidation;
        } else if (
            err.code === AXIOS_CONNECTION_ERR_CODE ||
            err.message === AXIOS_NO_NETWORK_ERR_MSG
        ) {
            errorMessage = strings.noNetwork;
        } else {
            errorMessage = strings.serverError;
        }

        return {
            generic: [errorMessage],
        };
    }

    return {
        generic: [strings.dataError],
    };
}

// TODO: This should only accept string[] once API is updated
export function getDisplayString(messages?: string[] | string) {
    if (Array.isArray(messages)) {
        return messages?.join(" ") || "";
    }
    return messages;
}

export function getGenericErrorStr(validation: Validation): string | undefined {
    const genericValidation = validation.generic;
    return genericValidation ? getDisplayString(genericValidation) : undefined;
}
